<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-12">
          <validated-form-select name="invoicePrefix" :options="invoicePrefixes" label="Objekt:"
                                 v-model="invoicePrefix" validate="required" :validator="$validator"
                                 value-field="code" text-field="label"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import gateway from '@/services/gateway'
  import ValidatedFormSelect from '../ValidatedFormSelect'

  export default {
    props: ['invoice'],
    components: {ValidatedFormSelect},
    data() {
      return {
        invoicePrefix: null,
        invoicePrefixes: []
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/invoices/${this.invoice.id}/prefix`, {prefix: this.invoicePrefix}).then(() => this.$emit('done'))
        })
      },
    },
    created() {
      this.invoicePrefix = this.invoice.number.substr(0, 2)
       gateway.get('/configuration/invoice-prefixes').then(r => this.invoicePrefixes.splice(0, 0, ...r.data))
    }
  }
</script>
